"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    fi: {
        FileInput: {
            changeImage: 'Lataa kuva',
            maxImageSizeHint: 'Sallitut muodot: JPG tai PNG. Kuvan enimmäiskoko on 10 Mt.',
            fileTooLarge: 'Kuva ylittää 10 Mt enimmäiskoon.',
            fileRejected: 'Tiedostoa ei voitu valita. Käytä JPG- tai PNG-kuvaa.',
        },
    },
};
